module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledBear_m_normal.fe002ae8.png";